import React from "react";
import { Check } from "lucide-react";
import { site, stats } from "../mock";

const points = [
  "Persoonlijk aanspreekpunt, van eerste idee tot thuiskomst",
  "Volledig op maat, passend bij jouw wensen en budget",
  "Flexibel bereikbaar, ook 's avonds en in het weekend",
  "Boeken met zekerheid dankzij garantieregeling",
];

const About = () => {
  return (
    <section id="over-mij" className="py-24 bg-[#fbfaf6]">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">
        <div className="reveal relative order-2 lg:order-1">
          <div className="img-zoom rounded-[2rem] overflow-hidden shadow-[0_25px_50px_-12px_rgba(83,14,47,0.3)] max-w-md">
            <img
              src={site.photos.portrait}
              alt="Natascha van Dam"
              className="w-full h-[520px] object-cover"
            />
          </div>
          <div className="absolute -top-5 -right-2 sm:right-10 bg-[#86233a] text-white rounded-2xl px-6 py-5 shadow-xl">
            <p className="font-display text-4xl leading-none">24+</p>
            <p className="text-xs uppercase tracking-[0.18em] mt-1 text-[#ffd7d4]">jaar ervaring</p>
          </div>
        </div>

        <div className="reveal order-1 lg:order-2">
          <span className="text-xs font-600 uppercase tracking-[0.25em] text-[#86233a]">Over mij</span>
          <h2 className="font-display mt-4 text-4xl lg:text-5xl font-600 text-[#1d1c1a] leading-tight">
            Hallo, ik ben Natascha
          </h2>
          <div className="mt-6 space-y-4 text-[#4b4642] text-lg leading-relaxed">
            <p>
              Al ruim 24 jaar draait mijn wereld om één ding: mensen laten genieten
              van de mooiste reizen. Als jouw persoonlijke Travel Counsellor neem ik
              het complete regelwerk uit handen, zodat jij alleen nog maar hoeft uit
              te kijken naar je vertrek.
            </p>
            <p>
              Ik luister goed naar wat jij wilt, denk mee en stel een reis samen die
              tot in de details klopt. Geen standaard aanbod, maar een vakantie die
              echt bij jou past. Persoonlijk, betrokken en altijd bereikbaar.
            </p>
          </div>

          <ul className="mt-8 grid sm:grid-cols-2 gap-3">
            {points.map((p) => (
              <li key={p} className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#ffd7d4]">
                  <Check size={14} className="text-[#86233a]" />
                </span>
                <span className="text-[#3a3632]">{p}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Stats */}
      <div className="max-w-6xl mx-auto px-6 mt-20">
        <div className="reveal grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((s) => (
            <div key={s.label} className="text-center rounded-2xl bg-white border border-[#efe6d8] py-8 px-4 shadow-[0_10px_30px_-15px_rgba(83,14,47,0.2)]">
              <p className="font-display text-4xl lg:text-5xl text-[#86233a]">{s.value}</p>
              <p className="mt-2 text-sm text-[#4b4642]">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
